import { BackArrow } from "../../../assets/icons-components/Icons";
import { onKeyActivate } from "../../../utils/a11y";

const SuperAdminProfileHeader = ({ onBack }) => (
  <div className="main2_header">
    <div className="main2_header_left">
      <div
        className="main2_header_left_arrow"
        onClick={onBack}
        onKeyDown={onKeyActivate(onBack)}
        role="button"
        tabIndex={0}
      >
        <BackArrow onClick={onBack} />
        <h3>Edit Profile</h3>
      </div>
    </div>
  </div>
);

export default SuperAdminProfileHeader;
